import React from "react"
import { Grid } from "@mui/material/"
import NatLangSearch from "./content/natLangSearch"

export default function NaturalLanguageSearch() {
  return (
    <Grid
      container
      xs={12}
      sm={12}
      md={12}
      lg={12}
      spacing={3}
      className="searchContainer"
    >
  
      <Grid item xs={12} className="marginCenter">
        <NatLangSearch />
      </Grid>

    </Grid>
  )
}
